<template>
    <form @submit.prevent="send" class="form mt-16">
        <h4 v-if="headline" class="tracking-wide text-secondary-500 text-lg font-headline uppercase mb-4" v-html="headline"></h4>
        <label for="footer-email" class="sr-only">Your email address</label>
        <input id="footer-email" v-model="email" type="email" placeholder="Your Email" required="required" class="border border-solid border-gray-700 border-2 rounded-full w-full text-lg py-4 px-8">
        <div class="mt-2">
            <input type="submit" value="Sign Up" class="rounded-full uppercase py-4 px-12 text-white text-lg bg-secondary-700 transition-colors hover:bg-secondary-500 focus:bg-secondary-500 cursor-pointer">
        </div>
    </form>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { ref, computed } from 'vue';
import { normalize } from './SmoothLink.vue';

export default {

    props: ['headline'],
    
    setup(props) {

        const email = ref('');

        const submission = computed(() => {
            return {
                status: 'active',
                1: email.value
            }
        });

        const send = async () => {
            let request = new Request('/email-signup', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(submission.value)
            });
            let response = await fetch(request);
            response = await response.json();

            if (!response.ok) {
                return;
            }

            let url = normalize('/thank-you');
            let announce = new CustomEvent("goingSomewhereElse", {
                detail: {
                    href: url.toString()
                }
            });
            window.dispatchEvent(announce);
            if (!window.prefersReducedMotion()) {
                await window.wait(380);
            }
            Inertia.get(url.toString());

        };

        return {
            submission,
            email,
            send
        };

    }

}
</script>